import MediaSerializer from './base';

export default class Status extends MediaSerializer {}
